import { render } from "./ProjectPublicationComments.vue?vue&type=template&id=bfac1e0c&scoped=true"
import script from "./ProjectPublicationComments.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationComments.vue?vue&type=script&lang=js"

import "./ProjectPublicationComments.vue?vue&type=style&index=0&id=bfac1e0c&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfac1e0c"]])

export default __exports__